import script from "./NavView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavView.vue?vue&type=script&setup=true&lang=ts"

import "./NavView.vue?vue&type=style&index=0&id=d23b4a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d23b4a3a"]])

export default __exports__